import { useAnnouncements } from '@/hooks/useAnnouncements';
import { AnnouncementCard } from '@/components/home/AnnouncementCard';
import { Skeleton } from '@/components/ui/skeleton';
import { Megaphone, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Announcements() {
  const navigate = useNavigate();
  const { data: announcements, isLoading, error } = useAnnouncements(50);

  return (
    <div className="container max-w-4xl py-6 space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/')}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div className="flex items-center gap-2">
          <Megaphone className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">Avisos da Empresa</h1>
        </div>
      </div>

      {isLoading && (
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} className="h-24 w-full rounded-lg" />
          ))}
        </div>
      )}

      {error && (
        <p className="text-sm text-muted-foreground">
          Erro ao carregar avisos. Tente novamente mais tarde.
        </p>
      )}

      {!isLoading && !error && (!announcements || announcements.length === 0) && (
        <div className="bg-muted/50 rounded-lg p-12 text-center">
          <Megaphone className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">Nenhum aviso no momento.</p>
        </div>
      )}

      {announcements && announcements.length > 0 && (
        <div className="space-y-3">
          {announcements.map((announcement) => (
            <AnnouncementCard 
              key={announcement.id} 
              announcement={announcement} 
              defaultExpanded 
            />
          ))}
        </div>
      )}
    </div>
  );
}
